export default __webpack_public_path__ + "static/media/feature-chart.da91602a.png";